<!-- ---------------------------------------------------------------------- -->
<!--                          CABECERA DE LA SECCION                        -->
<!-- ---------------------------------------------------------------------- -->

<div class="z-page-head z-rise">
  <div>
    <h1 class="z-page-title">Explorar</h1>
    <p class="z-page-subtitle">
      Dónde está el problema: geografía, sucursales, regiones y monto de compra.
    </p>
  </div>

  <div class="z-page-actions">
    <button class="z-btn z-btn--glass" type="button" (click)="descargar()">
      <i class="bi bi-download" aria-hidden="true"></i> Descargar CSV
    </button>
  </div>
</div>

<app-filter-bar [fields]="filtros"
                [selected]="seleccion"
                (selectedChange)="onFiltros($event)" />

<app-section-tabs [tabs]="tabs" [(active)]="tab" />

@switch (tab) {

  <!-- -------------------------------------------------------------- MAPA -->
  @case ('mapa') {
    <div class="exp-tab" role="tabpanel" aria-labelledby="z-tab-mapa">

      <!-- Fuera del panel a propósito: .z-btn-group ya trae su propio
           desenfoque y anidarlo sobre otro cristal ensucia el resultado. -->
      <div class="exp-map-toolbar z-rise z-rise-1">
        <div class="exp-map-field">
          <label class="exp-label" for="exp-indicador">Selecciona el indicador</label>
          <select id="exp-indicador"
                  class="z-native-select exp-map-select"
                  [value]="indicador"
                  (change)="onIndicador($any($event.target).value)">
            @for (opcion of indicadores; track opcion) {
              <option [value]="opcion">{{ opcion }}</option>
            }
          </select>
        </div>

        <div class="z-btn-group exp-map-actions" role="group" aria-label="Descargar el mapa">
          <button class="z-btn z-btn--purple" type="button" (click)="descargarMapaImagen()">IMAGEN</button>
          <button class="z-btn z-btn--purple" type="button" (click)="imprimirMapa()">PDF</button>
        </div>
      </div>

      <section class="z-panel exp-map-panel z-rise z-rise-2">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">NPS · Radiografía por estado</h2>
            <p class="z-panel-hint">
              Indicador: {{ indicador }}. Cada estado se tiñe con el semáforo del programa.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-map-chart [data]="mapa" [height]="620" (chartReady)="onMapaListo($event)" />
        </div>
      </section>

      <section class="z-panel exp-estados-panel z-rise z-rise-3">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Detalle por estado</h2>
            <p class="z-panel-hint">
              Abre la columna HISTÓRICO para ver la serie mensual del estado.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <!-- La clase va en el host y no en la tabla: app-data-table es
               compartida y no expone un input para la clase del <table>; la
               regla global pega la primera celda de cualquier fila descendiente. -->
          <app-data-table
            class="z-table--sticky-first"
            [columns]="columnasEstado"
            exportTitle="NPS · detalle por estado"
            [exportFilters]="filtrosTexto"
            [rows]="estados"
            [exportButtons]="exportacionMapa"
            [showLengthSelect]="true"
            [showInfo]="true"
            [pageSize]="10"
            (iconAction)="abrirHistoricoEstado($event.row)" />
        </div>
      </section>

    </div>
  }

  <!-- -------------------------------------------------------- SUCURSALES -->
  @case ('sucursales') {
    <div class="exp-tab" role="tabpanel" aria-labelledby="z-tab-sucursales">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">NPS por sucursal</h2>
            <p class="z-panel-hint">
              El universo completo de sucursales, ordenado de mayor a menor NPS.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-data-table
            [columns]="columnasSucursalNps"
            exportTitle="NPS por sucursal"
            [exportFilters]="filtrosTexto"
            [rows]="sucursales"
            [exportButtons]="exportacion"
            [searchable]="true"
            [showLengthSelect]="true"
            [showInfo]="true"
            [pageSize]="10" />
        </div>
      </section>

      <section class="z-panel z-rise z-rise-2">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Ranking por sucursal</h2>
            <p class="z-panel-hint">
              Neto general y su apertura por comerciante y consumidor final.
            </p>
          </div>

          <div class="z-panel-actions">
            <span class="z-scroll-hint">
              <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
              Desliza en horizontal para ver las 9 columnas
            </span>
          </div>
        </header>

        <div class="z-panel-body exp-ranking">
          <!-- Se pega CLAVE, la primera columna: es la etiqueta corta de la
               sucursal y cabe en 90px. Pegar además SUCURSAL (260px) dejaría
               un teléfono de 375px sin superficie donde desplazar. -->
          <app-data-table
            class="z-table--sticky-first"
            [columns]="columnasRanking"
            exportTitle="Ranking por sucursal"
            [exportFilters]="filtrosTexto"
            [rows]="rankingSucursal"
            [exportButtons]="exportacionPrint"
            [showLengthSelect]="true"
            [showInfo]="true"
            [pageSize]="10"
            (iconAction)="abrirHistorico($event.row.sucursal, $event.row.neto)" />
        </div>
      </section>

      <section class="z-panel z-rise z-rise-3">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">CSAT por tienda</h2>
            <p class="z-panel-hint">
              Satisfacción por categoría. «N/D» marca a la tienda sin muestra
              suficiente en el periodo y se muestra en tono tenue.
            </p>
          </div>

          <div class="z-panel-actions">
            <span class="z-scroll-hint">
              <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
              Desliza en horizontal para ver todas las categorías
            </span>
          </div>
        </header>

        <div class="z-panel-body exp-csat">
          <app-data-table
            class="z-table--sticky-first"
            [columns]="columnasCsat"
            exportTitle="CSAT por tienda"
            [exportFilters]="filtrosTexto"
            [rows]="csatTiendas"
            [exportButtons]="exportacion"
            [showLengthSelect]="true"
            [showInfo]="true"
            [pageSize]="10" />
        </div>
      </section>

    </div>
  }

  <!-- ---------------------------------------------------------- REGIONES -->
  @case ('regiones') {
    <div class="exp-tab" role="tabpanel" aria-labelledby="z-tab-regiones">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Ranking por región, zona y sucursal</h2>
            <p class="z-panel-hint">
              Despliega una fila para ver su desglose completo; el ícono abre el histórico.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-data-table
            [columns]="columnasRegion"
            exportTitle="Ranking por región, zona y sucursal"
            [exportFilters]="filtrosTexto"
            [rows]="rankingRegion"
            [exportButtons]="exportacion"
            [showInfo]="true"
            [pageSize]="10"
            [expandable]="true"
            (iconAction)="abrirHistorico($event.row.variable, $event.row.nps)" />
        </div>
      </section>

    </div>
  }

  <!-- ------------------------------------------------------------ TICKET -->
  @case ('ticket') {
    <div class="exp-tab" role="tabpanel" aria-labelledby="z-tab-ticket">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Detalle por monto de compra</h2>
            <p class="z-panel-hint">
              Cómo cambia la recomendación según el ticket de la visita.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-data-table
            [columns]="columnasMonto"
            exportTitle="Detalle por monto de compra"
            [exportFilters]="filtrosTexto"
            [rows]="montoCompra"
            [exportButtons]="exportacion"
            [showInfo]="true"
            [pageSize]="10"
            (iconAction)="abrirHistorico($event.row.rango, $event.row.neto)" />
        </div>
      </section>

    </div>
  }
}

@if (historialAbierto) {
  <app-history-modal
    [title]="historialTitulo"
    [points]="historialPuntos"
    (closed)="cerrarHistorico()" />
}
